// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import GLOBAL from 'common/js/util/global_code'
import 'common/style/common.css'
import 'common/style/busi.css'
import '@/assets/css/base.css'
/*引入公共样式*/
import 'common/js/language/validate'
import 'common/js/filter/filter'
import 'common/js/filter/directive'
import '@/assets/font/siyuan.css'
import '@/assets/font/siyuan2.css'
import '@/assets/font/DINA.css'
import { parseTime, getCookie, setCookie, delCookie } from 'common/js/util/util'
/*引入阿里矢量图标*/
import axios from 'axios'
import store from './store/store'
import VueCookie from 'vue-cookie'
import { post } from 'api/post'
import { get } from 'api/get'
import { baseUrl, baseUrl2 } from 'common/env'

import 'base/utils/directives.js'
import Vant from 'vant'
import { Toast } from 'vant'
import 'vant/lib/index.css'
import * as math from 'mathjs'
import accounting from 'accounting'
import {
  add,
  divide,
  multiply,
  roundDown,
  roundUp,
  subtract,
  roundHalfUp,
} from 'common/js/util/calculate'

Vue.use(Vant)
Vue.prototype.axios = axios
Vue.use(VueCookie)
Vue.prototype.GLOBAL = GLOBAL
Vue.prototype.$math = math
Vue.prototype.$add = add
Vue.prototype.$subtract = subtract
Vue.prototype.$multiply = multiply
Vue.prototype.$divide = divide
Vue.prototype.$roundDown = roundDown
Vue.prototype.$roundUp = roundUp
Vue.prototype.$roundHalfUp = roundHalfUp
Vue.prototype.$accounting = accounting
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$parseTime = parseTime

Vue.prototype.$getCookie = getCookie
Vue.prototype.$setCookie = setCookie
Vue.prototype.$delCookie = delCookie

// 将所有 Toast 的展示时长设置为 2000 毫秒
Toast.setDefaultOptions({ duration: GLOBAL.TOAST_DURATION })

//http://localhost:8085/oauth2/authorize/JH001?redirectUrl=https://www.baidu.com

const TOKEN =
  'eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImZlMzkwNzY1LWRlMGItNDg2MC1hODJiLWYxOThiNDBkZDI3MyJ9.BPy2a1O5I1GhAm973fW68dJS4ASFGL7GMZT9f9hwID3Jk0mEuEXi0HEU2z1gFNMej5ybe4oCAH4LQFUhrR31wQ'
router.beforeEach((to, from, next) => {
  // setCookie('token_bshop','eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjkxZjU3ODkyLTlmMTYtNDMzNS1iZmUxLTk4ZTdmOGM5Y2ZhMSJ9.rqVwAdn-_jGjbJCwpZpp7t4pYP_-E9P3Ixq8cMp7tVmxn-yI7M7Z4oMOSrWKY2jcNjonz26xl9mbY7h4ULXOyg')
  let _token = getCookie('token_bshop')

  // if (!_token) {
  //   setCookie('token_bshop', TOKEN)
  // }

  if (to.query.isTest === 'Y') {
    // Vue.prototype.$cookie.delete('token_bshop')
    delCookie('token_bshop')
    setCookie('token_bshop', TOKEN)
  }

  // if (to.query.token && !_token) {
  if (to.query.token) {
    // 登录过期逻辑没有，临时改为：只要有新token，就覆盖原token
    let _token = to.query.token
    setCookie('token_bshop', _token)
    next()
  } else {
    if (_token) {
      next()
    } else {
      console.log(111)
      console.log(to)
      let url =
        baseUrl +
        'oauth2/authorize/JH001?redirectUrl=' +
        encodeURIComponent(baseUrl2 + to.fullPath)
      console.log(url)
      window.location.href = url
    }
  }
})

/* eslint-disable no-new */
const $vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})

Vue.prototype.$jump = (path) => {
  console.log(path)
  if (path.startsWith('/')) {
    $vm.$router.push(path)
  } else if (path.startsWith('http')) {
    window.location.href = path
  }
}



// WEBPACK FOOTER //
// ./src/main.js